module.exports = __webpack_public_path__ + "static/logo1-1c36ca0b2b74e286a1f4612c6ecdb617.svg";